import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'success-pop-modal',
  templateUrl: './success-pop-modal.component.html',
  styleUrls: ['./success-pop-modal.component.scss'],
})
export class SuccessPopModalComponent implements OnInit {
  @Input() moduleName: string;
  @Input() isBenefit: boolean = true;
  @Input() img: string;
  public message: string;

  constructor(
    private modalController: ModalController,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    if (this.isBenefit) {
      this.message =
        this.moduleName +
        ' ' +
        this.translate.instant(
          'modals.success_pop_modal.benefit_sucessfully_activated'
        );
    } else {
      this.message = this.moduleName;
    }

    setTimeout(() => {
      this.dismissModal();
    }, 2000);
  }

  dismissModal() {
    this.modalController.dismiss();
  }
}
